// // // pages/assessment/AssessmentQuestions.jsx
// // import { useState, useEffect } from "react";
// // import { useParams, useNavigate } from "react-router-dom";
// // import axios from "axios";
// // import {
// //   Box,
// //   Typography,
// //   Button,
// //   IconButton,
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   TextField,
// //   Alert,
// //   CircularProgress,
// //   Breadcrumbs,
// //   Link,
// //   Paper,
// //   Grid,
// // } from "@mui/material";
// // import AddIcon from "@mui/icons-material/Add";
// // import EditIcon from "@mui/icons-material/Edit";
// // import DeleteIcon from "@mui/icons-material/Delete";
// // import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// // import { useATS } from "../atsModule/context/ATSContext";

// // const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

// // const AssessmentQuestions = () => {
// //   const { assessmentId } = useParams();
// //   const navigate = useNavigate();
// //   const { store_id } = useATS();

// //   const [assessment, setAssessment] = useState(null);
// //   const [questions, setQuestions] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState("");
// //   const [modalOpen, setModalOpen] = useState(false);
// //   const [editingQuestion, setEditingQuestion] = useState(null);
// //   const [formData, setFormData] = useState({
// //     question_text: "",
// //     options: ["", "", "", ""], // exactly 4 options
// //     correct_option: 0,
// //     max_score: 10,
// //     question_order: 0,
// //   });
// //   const [submitLoading, setSubmitLoading] = useState(false);

// //   const fetchData = async () => {
// //     if (!store_id && store_id !== 0) return;
// //     try {
// //       setLoading(true);
// //       // Get assessment details
// //       const assessmentRes = await axios.get(
// //         `${API_BASE}/api/assessment/assessments/${assessmentId}`,
// //       );
// //       setAssessment(assessmentRes.data.data);
// //       // Get questions
// //       const questionsRes = await axios.get(
// //         `${API_BASE}/api/assessment/assessment-questions/assessment/${assessmentId}`,
// //       );
// //       setQuestions(questionsRes.data.data || []);
// //       setError("");
// //     } catch (err) {
// //       console.error(err);
// //       setError("Failed to load questions");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (assessmentId) fetchData();
// //   }, [assessmentId, store_id]);

// //   const handleOpenModal = (question = null) => {
// //     if (question) {
// //       setEditingQuestion(question);
// //       // Ensure options array has exactly 4 items
// //       const opts =
// //         question.options && question.options.length === 4
// //           ? question.options
// //           : ["", "", "", ""];
// //       setFormData({
// //         question_text: question.question_text,
// //         options: opts,
// //         correct_option: question.correct_option,
// //         max_score: question.max_score,
// //         question_order: question.question_order || 0,
// //       });
// //     } else {
// //       setEditingQuestion(null);
// //       setFormData({
// //         question_text: "",
// //         options: ["", "", "", ""],
// //         correct_option: 0,
// //         max_score: 10,
// //         question_order: questions.length + 1,
// //       });
// //     }
// //     setModalOpen(true);
// //   };

// //   const handleCloseModal = () => {
// //     setModalOpen(false);
// //     setEditingQuestion(null);
// //   };

// //   const handleFormChange = (e) => {
// //     setFormData({ ...formData, [e.target.name]: e.target.value });
// //   };

// //   const handleOptionChange = (index, value) => {
// //     const newOptions = [...formData.options];
// //     newOptions[index] = value;
// //     setFormData({ ...formData, options: newOptions });
// //   };

// //   const handleSaveQuestion = async () => {
// //     if (!formData.question_text.trim()) {
// //       alert("Question text is required");
// //       return;
// //     }
// //     if (formData.options.some((opt) => !opt.trim())) {
// //       alert("All 4 options must be filled");
// //       return;
// //     }
// //     setSubmitLoading(true);
// //     try {
// //       const payload = {
// //         assessment_id: parseInt(assessmentId),
// //         question_text: formData.question_text,
// //         options: formData.options,
// //         correct_option: formData.correct_option,
// //         max_score: formData.max_score,
// //         question_order: formData.question_order,
// //       };
// //       if (editingQuestion) {
// //         await axios.put(
// //           `${API_BASE}/api/assessment/assessment-questions/${editingQuestion.id}`,
// //           payload,
// //         );
// //       } else {
// //         await axios.post(
// //           `${API_BASE}/api/assessment/assessment-questions`,
// //           payload,
// //         );
// //       }
// //       fetchData();
// //       handleCloseModal();
// //     } catch (err) {
// //       console.error(err);
// //       alert(err.response?.data?.statusMessage || "Failed to save question");
// //     } finally {
// //       setSubmitLoading(false);
// //     }
// //   };

// //   const handleDeleteQuestion = async (questionId) => {
// //     if (!window.confirm("Delete this question?")) return;
// //     try {
// //       await axios.delete(
// //         `${API_BASE}/api/assessment/assessment-questions/${questionId}`,
// //       );
// //       fetchData();
// //     } catch (err) {
// //       alert("Failed to delete question");
// //     }
// //   };

// //   if (loading)
// //     return <CircularProgress sx={{ display: "block", mx: "auto", mt: 4 }} />;
// //   if (error) return <Alert severity="error">{error}</Alert>;

// //   return (
// //     <Box>
// //       <Breadcrumbs sx={{ mb: 2 }}>
// //         <Link
// //           component="button"
// //           variant="body2"
// //           onClick={() => navigate("/ats/assessments")}
// //         >
// //           Folders
// //         </Link>
// //         <Link component="button" variant="body2" onClick={() => navigate(-1)}>
// //           Assessments
// //         </Link>
// //         <Typography color="text.primary">
// //           {assessment?.title} - Questions
// //         </Typography>
// //       </Breadcrumbs>

// //       <Box
// //         sx={{
// //           display: "flex",
// //           justifyContent: "space-between",
// //           alignItems: "center",
// //           mb: 3,
// //         }}
// //       >
// //         <Typography variant="h4" fontWeight={600}>
// //           Questions for {assessment?.title}
// //         </Typography>
// //         <Button
// //           variant="contained"
// //           startIcon={<AddIcon />}
// //           onClick={() => handleOpenModal()}
// //           sx={{ bgcolor: "#1a2a3a" }}
// //         >
// //           Add Question
// //         </Button>
// //       </Box>

// //       {questions.length === 0 ? (
// //         <Alert severity="info">
// //           No questions yet. Click "Add Question" to create one.
// //         </Alert>
// //       ) : (
// //         questions.map((q, idx) => (
// //           <Paper key={q.id} sx={{ p: 2, mb: 2 }}>
// //             <Box
// //               sx={{
// //                 display: "flex",
// //                 justifyContent: "space-between",
// //                 alignItems: "flex-start",
// //               }}
// //             >
// //               <Box sx={{ flex: 1 }}>
// //                 <Typography variant="h6">
// //                   Q{idx + 1}: {q.question_text}
// //                 </Typography>
// //                 <Typography
// //                   variant="body2"
// //                   color="text.secondary"
// //                   sx={{ mt: 1 }}
// //                 >
// //                   Options:
// //                 </Typography>
// //                 <ul style={{ marginTop: 4 }}>
// //                   {q.options.map((opt, optIdx) => (
// //                     <li key={optIdx}>
// //                       <Typography variant="body2">
// //                         {opt} {q.correct_option === optIdx && "✅ (Correct)"}
// //                       </Typography>
// //                     </li>
// //                   ))}
// //                 </ul>
// //                 <Typography variant="caption" display="block" sx={{ mt: 1 }}>
// //                   Score: {q.max_score} | Order: {q.question_order}
// //                 </Typography>
// //               </Box>
// //               <Box>
// //                 <IconButton onClick={() => handleOpenModal(q)}>
// //                   <EditIcon />
// //                 </IconButton>
// //                 <IconButton onClick={() => handleDeleteQuestion(q.id)}>
// //                   <DeleteIcon />
// //                 </IconButton>
// //               </Box>
// //             </Box>
// //           </Paper>
// //         ))
// //       )}

// //       {/* Add/Edit Question Modal */}
// //       <Dialog
// //         open={modalOpen}
// //         onClose={handleCloseModal}
// //         maxWidth="md"
// //         fullWidth
// //       >
// //         <DialogTitle>
// //           {editingQuestion ? "Edit Question" : "New Question"}
// //         </DialogTitle>
// //         <DialogContent>
// //           <TextField
// //             autoFocus
// //             margin="dense"
// //             label="Question Text"
// //             name="question_text"
// //             fullWidth
// //             multiline
// //             rows={2}
// //             value={formData.question_text}
// //             onChange={handleFormChange}
// //             required
// //           />
// //           <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>
// //             Options (exactly 4)
// //           </Typography>
// //           <Grid container spacing={2}>
// //             {[0, 1, 2, 3].map((idx) => (
// //               <Grid item xs={12} sm={6} key={idx}>
// //                 <TextField
// //                   margin="dense"
// //                   label={`Option ${idx + 1}`}
// //                   fullWidth
// //                   value={formData.options[idx]}
// //                   onChange={(e) => handleOptionChange(idx, e.target.value)}
// //                   required
// //                 />
// //               </Grid>
// //             ))}
// //           </Grid>
// //           <TextField
// //             margin="dense"
// //             label="Correct Option Index (0-3)"
// //             name="correct_option"
// //             type="number"
// //             fullWidth
// //             value={formData.correct_option}
// //             onChange={handleFormChange}
// //             inputProps={{ min: 0, max: 3 }}
// //             required
// //             sx={{ mt: 2 }}
// //           />
// //           <TextField
// //             margin="dense"
// //             label="Max Score"
// //             name="max_score"
// //             type="number"
// //             fullWidth
// //             value={formData.max_score}
// //             onChange={handleFormChange}
// //             inputProps={{ min: 1 }}
// //             required
// //           />
// //           <TextField
// //             margin="dense"
// //             label="Question Order"
// //             name="question_order"
// //             type="number"
// //             fullWidth
// //             value={formData.question_order}
// //             onChange={handleFormChange}
// //             inputProps={{ min: 0 }}
// //             helperText="Order in which questions appear"
// //           />
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={handleCloseModal}>Cancel</Button>
// //           <Button
// //             onClick={handleSaveQuestion}
// //             variant="contained"
// //             disabled={submitLoading}
// //           >
// //             {submitLoading ? (
// //               <CircularProgress size={24} />
// //             ) : editingQuestion ? (
// //               "Update"
// //             ) : (
// //               "Create"
// //             )}
// //           </Button>
// //         </DialogActions>
// //       </Dialog>
// //     </Box>
// //   );
// // };

// // export default AssessmentQuestions;
// // pages/assessment/AssessmentQuestions.jsx
// import { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   Box,
//   Typography,
//   Button,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Alert,
//   CircularProgress,
//   Breadcrumbs,
//   Link,
//   Paper,
//   Grid,
//   Chip,
//   Tooltip,
//   Skeleton,
// } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
// import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
// import NavigateNextIcon from "@mui/icons-material/NavigateNext";
// import { useATS } from "../atsModule/context/ATSContext";

// const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

// // Blue palette (same as FolderAssessments)
// const BLUE = {
//   50: "#eff6ff",
//   100: "#dbeafe",
//   200: "#bfdbfe",
//   300: "#93c5fd",
//   400: "#60a5fa",
//   500: "#3b82f6",
//   600: "#2563eb",
//   700: "#1d4ed8",
//   900: "#1e3a8a",
// };

// const QUESTION_ACCENTS = [
//   {
//     border: "#2563eb",
//     glow: "rgba(37,99,235,.12)",
//     bg: "#eff6ff",
//     icon: "#2563eb",
//   },
//   {
//     border: "#7c3aed",
//     glow: "rgba(124,58,237,.12)",
//     bg: "#f5f3ff",
//     icon: "#7c3aed",
//   },
//   {
//     border: "#0891b2",
//     glow: "rgba(8,145,178,.12)",
//     bg: "#ecfeff",
//     icon: "#0891b2",
//   },
//   {
//     border: "#16a34a",
//     glow: "rgba(22,163,74,.12)",
//     bg: "#f0fdf4",
//     icon: "#16a34a",
//   },
//   {
//     border: "#ea580c",
//     glow: "rgba(234,88,12,.12)",
//     bg: "#fff7ed",
//     icon: "#ea580c",
//   },
//   {
//     border: "#db2777",
//     glow: "rgba(219,39,119,.12)",
//     bg: "#fdf2f8",
//     icon: "#db2777",
//   },
// ];

// // Inject keyframes once
// const KF_ID = "fa-keyframes-questions";
// if (typeof document !== "undefined" && !document.getElementById(KF_ID)) {
//   const style = document.createElement("style");
//   style.id = KF_ID;
//   style.textContent = `
//     @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
//     @keyframes fadeUp { from{opacity:0;transform:translateY(22px)} to{opacity:1;transform:translateY(0)} }
//     @keyframes float   { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-7px)} }
//     @keyframes shimmer { 0%{background-position:-200% 0} 100%{background-position:200% 0} }
//   `;
//   document.head.appendChild(style);
// }

// const fontFam = "'Plus Jakarta Sans', sans-serif";

// const inputSx = {
//   mt: 1,
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "12px",
//     fontFamily: fontFam,
//     "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: BLUE[400] },
//     "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//       borderColor: BLUE[600],
//     },
//   },
//   "& .MuiInputLabel-root.Mui-focused": { color: BLUE[600] },
// };

// const primaryBtnSx = {
//   background: "#0c8a9b",
//   color: "#fff",
//   borderRadius: "11px",
//   px: 2.5,
//   py: 1,
//   fontFamily: fontFam,
//   fontWeight: 600,
//   boxShadow: `0 4px 14px #0c8a9b`,
//   "&:hover": {
//     transform: "translateY(-2px)",
//     boxShadow: `0 8px 22px #0c8a9b`,
//     background: `linear-gradient(135deg, #0c8a9b 0%, #0c8a9b 100%)`,
//   },
//   transition: "all 0.2s ease",
// };

// const SkeletonCard = () => (
//   <Paper
//     sx={{
//       borderRadius: "20px",
//       p: 2,
//       mb: 2,
//       boxShadow: "0 4px 12px rgba(0,0,0,.05)",
//     }}
//   >
//     <Box
//       sx={{
//         display: "flex",
//         justifyContent: "space-between",
//         alignItems: "flex-start",
//       }}
//     >
//       <Box sx={{ flex: 1 }}>
//         <Skeleton variant="text" width="60%" height={28} />
//         <Skeleton variant="text" width="80%" height={20} sx={{ mt: 1 }} />
//         <Skeleton variant="text" width="40%" height={16} sx={{ mt: 2 }} />
//       </Box>
//       <Box sx={{ display: "flex", gap: 1 }}>
//         <Skeleton variant="circular" width={32} height={32} />
//         <Skeleton variant="circular" width={32} height={32} />
//       </Box>
//     </Box>
//   </Paper>
// );

// const EmptyState = ({ onAdd }) => (
//   <Box
//     sx={{
//       display: "flex",
//       flexDirection: "column",
//       alignItems: "center",
//       py: 12,
//       gap: 2,
//       animation: "fadeUp 0.5s ease both",
//     }}
//   >
//     <Box
//       sx={{
//         width: 88,
//         height: 88,
//         borderRadius: "50%",
//         background: `linear-gradient(135deg, ${BLUE[100]} 0%, ${BLUE[200]} 100%)`,
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         animation: "float 3s ease-in-out infinite",
//         boxShadow: `0 8px 24px ${BLUE[200]}`,
//       }}
//     >
//       <AddIcon sx={{ fontSize: 42, color: BLUE[600] }} />
//     </Box>
//     <Typography
//       variant="h6"
//       fontWeight={700}
//       color="#0f172a"
//       fontFamily={fontFam}
//     >
//       No questions yet
//     </Typography>
//     <Typography variant="body2" color="text.secondary" fontFamily={fontFam}>
//       Click "Add Question" to start building your assessment.
//     </Typography>
//     <Button
//       variant="contained"
//       startIcon={<AddIcon />}
//       onClick={onAdd}
//       sx={primaryBtnSx}
//     >
//       Add Question
//     </Button>
//   </Box>
// );

// const AssessmentQuestions = () => {
//   const { assessmentId } = useParams();
//   const navigate = useNavigate();
//   const { store_id } = useATS();

//   const [assessment, setAssessment] = useState(null);
//   const [questions, setQuestions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [modalOpen, setModalOpen] = useState(false);
//   const [editingQuestion, setEditingQuestion] = useState(null);
//   const [formData, setFormData] = useState({
//     question_text: "",
//     options: ["", "", "", ""],
//     correct_option: 0,
//     max_score: 10,
//     question_order: 0,
//   });
//   const [submitLoading, setSubmitLoading] = useState(false);

//   const fetchData = async () => {
//     if (!store_id && store_id !== 0) return;
//     try {
//       setLoading(true);
//       const assessmentRes = await axios.get(
//         `${API_BASE}/api/assessment/assessments/${assessmentId}`,
//       );
//       setAssessment(assessmentRes.data.data);
//       const questionsRes = await axios.get(
//         `${API_BASE}/api/assessment/assessment-questions/assessment/${assessmentId}`,
//       );
//       setQuestions(questionsRes.data.data || []);
//       setError("");
//     } catch (err) {
//       console.error(err);
//       setError("Failed to load questions");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (assessmentId) fetchData();
//   }, [assessmentId, store_id]);

//   const handleOpenModal = (question = null) => {
//     if (question) {
//       setEditingQuestion(question);
//       const opts =
//         question.options && question.options.length === 4
//           ? question.options
//           : ["", "", "", ""];
//       setFormData({
//         question_text: question.question_text,
//         options: opts,
//         correct_option: question.correct_option,
//         max_score: question.max_score,
//         question_order: question.question_order || 0,
//       });
//     } else {
//       setEditingQuestion(null);
//       setFormData({
//         question_text: "",
//         options: ["", "", "", ""],
//         correct_option: 0,
//         max_score: 10,
//         question_order: questions.length + 1,
//       });
//     }
//     setModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setModalOpen(false);
//     setEditingQuestion(null);
//   };

//   const handleFormChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleOptionChange = (index, value) => {
//     const newOptions = [...formData.options];
//     newOptions[index] = value;
//     setFormData({ ...formData, options: newOptions });
//   };

//   const handleSaveQuestion = async () => {
//     if (!formData.question_text.trim()) {
//       alert("Question text is required");
//       return;
//     }
//     if (formData.options.some((opt) => !opt.trim())) {
//       alert("All 4 options must be filled");
//       return;
//     }
//     setSubmitLoading(true);
//     try {
//       const payload = {
//         assessment_id: parseInt(assessmentId),
//         question_text: formData.question_text,
//         options: formData.options,
//         correct_option: formData.correct_option,
//         max_score: formData.max_score,
//         question_order: formData.question_order,
//       };
//       if (editingQuestion) {
//         await axios.put(
//           `${API_BASE}/api/assessment/assessment-questions/${editingQuestion.id}`,
//           payload,
//         );
//       } else {
//         await axios.post(
//           `${API_BASE}/api/assessment/assessment-questions`,
//           payload,
//         );
//       }
//       fetchData();
//       handleCloseModal();
//     } catch (err) {
//       console.error(err);
//       alert(err.response?.data?.statusMessage || "Failed to save question");
//     } finally {
//       setSubmitLoading(false);
//     }
//   };

//   const handleDeleteQuestion = async (questionId) => {
//     if (!window.confirm("Delete this question?")) return;
//     try {
//       await axios.delete(
//         `${API_BASE}/api/assessment/assessment-questions/${questionId}`,
//       );
//       fetchData();
//     } catch (err) {
//       alert("Failed to delete question");
//     }
//   };

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           minHeight: "100vh",
//           background: "#f8fafc",
//           fontFamily: fontFam,
//           p: { xs: 2, sm: 4 },
//         }}
//       >
//         <Breadcrumbs sx={{ mb: 3 }}>
//           <Link
//             component="button"
//             variant="body2"
//             onClick={() => navigate("/ats/assessments")}
//             underline="hover"
//             sx={{
//               color: BLUE[600],
//               fontFamily: fontFam,
//               fontWeight: 500,
//               fontSize: "0.85rem",
//             }}
//           >
//             Folders
//           </Link>
//           <Typography sx={{ color: "#64748b", fontSize: "0.85rem" }}>
//             ...
//           </Typography>
//         </Breadcrumbs>
//         <Skeleton variant="rounded" width="100%" height={60} sx={{ mb: 3 }} />
//         {[...Array(3)].map((_, i) => (
//           <SkeletonCard key={i} />
//         ))}
//       </Box>
//     );
//   }

//   if (error) return <Alert severity="error">{error}</Alert>;

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         background: "#f8fafc",
//         fontFamily: fontFam,
//         p: { xs: 2, sm: 4 },
//       }}
//     >
//       {/* Breadcrumbs */}
//       <Breadcrumbs
//         separator={
//           <NavigateNextIcon fontSize="small" sx={{ color: "#94a3b8" }} />
//         }
//         sx={{ mb: 3, animation: "fadeUp 0.35s ease both" }}
//       >
//         <Link
//           component="button"
//           variant="body2"
//           onClick={() => navigate("/ats/assessments")}
//           underline="hover"
//           sx={{
//             color: BLUE[600],
//             fontFamily: fontFam,
//             fontWeight: 500,
//             fontSize: "0.85rem",
//           }}
//         >
//           Folders
//         </Link>
//         <Link
//           component="button"
//           variant="body2"
//           onClick={() => navigate(-1)}
//           underline="hover"
//           sx={{
//             color: BLUE[600],
//             fontFamily: fontFam,
//             fontWeight: 500,
//             fontSize: "0.85rem",
//           }}
//         >
//           Assessments
//         </Link>
//         <Typography
//           sx={{ color: "#64748b", fontFamily: fontFam, fontSize: "0.85rem" }}
//         >
//           {assessment?.title} – Questions
//         </Typography>
//       </Breadcrumbs>

//       {/* Quote Banner */}
//       <Box
//         sx={{
//           mb: 4,
//           p: "13px 20px",
//           borderRadius: "14px",
//           background: "#0c8a9b",
//           display: "flex",
//           alignItems: "center",
//           gap: 1.5,
//           animation: "fadeUp 0.4s ease both",
//           boxShadow: `0 4px 18px ${BLUE[200]}`,
//         }}
//       >
//         <AutoAwesomeIcon
//           sx={{ color: "#fde68a", fontSize: 18, flexShrink: 0 }}
//         />
//         <Typography
//           sx={{
//             color: "#fff",
//             fontSize: "0.82rem",
//             fontWeight: 500,
//             fontStyle: "italic",
//             fontFamily: fontFam,
//           }}
//         >
//           "Questions are the engines of intellect."
//         </Typography>
//       </Box>

//       {/* Header */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           mb: 4,
//           animation: "fadeUp 0.45s ease both",
//           flexWrap: "wrap",
//           gap: 2,
//         }}
//       >
//         <Box>
//           <Typography
//             variant="h4"
//             sx={{
//               fontWeight: 800,
//               fontFamily: fontFam,
//               color: "#0f172a",
//               letterSpacing: "-0.5px",
//             }}
//           >
//             Questions for {assessment?.title}
//           </Typography>
//           <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
//             {questions.length} question{questions.length !== 1 ? "s" : ""}
//           </Typography>
//         </Box>
//         <Button
//           variant="contained"
//           startIcon={<AddIcon />}
//           onClick={() => handleOpenModal()}
//           sx={primaryBtnSx}
//         >
//           Add Question
//         </Button>
//       </Box>

//       {/* Questions List */}
//       {questions.length === 0 && !loading && (
//         <EmptyState onAdd={() => handleOpenModal()} />
//       )}

//       {questions.length > 0 && (
//         <Box sx={{ mt: 2 }}>
//           {questions.map((q, idx) => {
//             const accent = QUESTION_ACCENTS[idx % QUESTION_ACCENTS.length];
//             const delay = `${idx * 0.06}s`;
//             return (
//               <Paper
//                 key={q.id}
//                 sx={{
//                   p: 2.5,
//                   mb: 2.5,
//                   borderRadius: "20px",
//                   background: "#fff",
//                   border: `1px solid ${accent.border}20`,
//                   boxShadow: "0 4px 12px rgba(0,0,0,.03)",
//                   animation: `fadeUp 0.5s ease ${delay} both`,
//                   transition: "all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)",
//                   "&:hover": {
//                     transform: "translateY(-2px)",
//                     boxShadow: `0 12px 28px ${accent.glow}, 0 4px 12px rgba(0,0,0,.06)`,
//                     borderColor: accent.border + "80",
//                   },
//                 }}
//               >
//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "flex-start",
//                     flexWrap: "wrap",
//                     gap: 2,
//                   }}
//                 >
//                   <Box sx={{ flex: 1 }}>
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 1.5,
//                         mb: 1.5,
//                       }}
//                     >
//                       <DragIndicatorIcon
//                         sx={{ color: "#cbd5e1", fontSize: 20 }}
//                       />
//                       <Typography
//                         variant="h6"
//                         sx={{
//                           fontWeight: 700,
//                           fontFamily: fontFam,
//                           color: "#0f172a",
//                         }}
//                       >
//                         Q{idx + 1}: {q.question_text}
//                       </Typography>
//                     </Box>
//                     <Typography
//                       variant="body2"
//                       color="text.secondary"
//                       sx={{ mb: 1, fontFamily: fontFam }}
//                     >
//                       Options:
//                     </Typography>
//                     <Grid container spacing={1} sx={{ mb: 2 }}>
//                       {q.options.map((opt, optIdx) => (
//                         <Grid item xs={12} sm={6} key={optIdx}>
//                           <Box
//                             sx={{
//                               p: 1,
//                               borderRadius: "12px",
//                               background:
//                                 optIdx === q.correct_option
//                                   ? accent.bg
//                                   : "#f8fafc",
//                               border: `1px solid ${
//                                 optIdx === q.correct_option
//                                   ? accent.border
//                                   : "#e2e8f0"
//                               }`,
//                               transition: "all 0.2s",
//                             }}
//                           >
//                             <Typography
//                               variant="body2"
//                               sx={{
//                                 fontFamily: fontFam,
//                                 fontWeight:
//                                   optIdx === q.correct_option ? 600 : 400,
//                                 color:
//                                   optIdx === q.correct_option
//                                     ? accent.icon
//                                     : "#1e293b",
//                               }}
//                             >
//                               {opt}{" "}
//                               {optIdx === q.correct_option && "✅ (Correct)"}
//                             </Typography>
//                           </Box>
//                         </Grid>
//                       ))}
//                     </Grid>
//                     <Box sx={{ display: "flex", gap: 3 }}>
//                       <Chip
//                         label={`Score: ${q.max_score}`}
//                         size="small"
//                         sx={{
//                           fontFamily: fontFam,
//                           fontWeight: 500,
//                           background: "#f1f5f9",
//                           color: "#475569",
//                           borderRadius: "8px",
//                         }}
//                       />
//                       <Chip
//                         label={`Order: ${q.question_order}`}
//                         size="small"
//                         sx={{
//                           fontFamily: fontFam,
//                           fontWeight: 500,
//                           background: "#f1f5f9",
//                           color: "#475569",
//                           borderRadius: "8px",
//                         }}
//                       />
//                     </Box>
//                   </Box>
//                   <Box sx={{ display: "flex", gap: 0.5 }}>
//                     <Tooltip title="Edit question">
//                       <IconButton
//                         size="small"
//                         onClick={() => handleOpenModal(q)}
//                         sx={{
//                           color: "#94a3b8",
//                           borderRadius: "10px",
//                           "&:hover": { color: BLUE[600], background: BLUE[50] },
//                         }}
//                       >
//                         <EditIcon fontSize="small" />
//                       </IconButton>
//                     </Tooltip>
//                     <Tooltip title="Delete question">
//                       <IconButton
//                         size="small"
//                         onClick={() => handleDeleteQuestion(q.id)}
//                         sx={{
//                           color: "#94a3b8",
//                           borderRadius: "10px",
//                           "&:hover": {
//                             color: "#ef4444",
//                             background: "#fef2f2",
//                           },
//                         }}
//                       >
//                         <DeleteIcon fontSize="small" />
//                       </IconButton>
//                     </Tooltip>
//                   </Box>
//                 </Box>
//               </Paper>
//             );
//           })}
//         </Box>
//       )}

//       {/* Add/Edit Question Modal */}
//       <Dialog
//         open={modalOpen}
//         onClose={handleCloseModal}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: "20px",
//             boxShadow: "0 25px 60px rgba(0,0,0,0.15)",
//             overflow: "hidden",
//             fontFamily: fontFam,
//           },
//         }}
//       >
//         <Box
//           sx={{
//             height: 6,
//             background: `linear-gradient(90deg, ${BLUE[500]} 0%, ${BLUE[700]} 100%)`,
//           }}
//         />
//         <DialogTitle
//           sx={{
//             fontFamily: fontFam,
//             fontWeight: 700,
//             fontSize: "1.1rem",
//             color: "#0f172a",
//             pt: 3,
//             pb: 1,
//           }}
//         >
//           {editingQuestion ? "Edit Question" : "New Question"}
//         </DialogTitle>
//         <DialogContent sx={{ pt: 1 }}>
//           <TextField
//             autoFocus
//             margin="dense"
//             label="Question Text"
//             name="question_text"
//             fullWidth
//             multiline
//             rows={2}
//             value={formData.question_text}
//             onChange={handleFormChange}
//             required
//             sx={inputSx}
//           />
//           <Typography
//             variant="subtitle2"
//             sx={{
//               mt: 2,
//               mb: 1,
//               fontWeight: 600,
//               color: "#334155",
//               fontFamily: fontFam,
//             }}
//           >
//             Options (exactly 4)
//           </Typography>
//           <Grid container spacing={2}>
//             {[0, 1, 2, 3].map((idx) => (
//               <Grid item xs={12} sm={6} key={idx}>
//                 <TextField
//                   margin="dense"
//                   label={`Option ${idx + 1}`}
//                   fullWidth
//                   value={formData.options[idx]}
//                   onChange={(e) => handleOptionChange(idx, e.target.value)}
//                   required
//                   sx={inputSx}
//                 />
//               </Grid>
//             ))}
//           </Grid>
//           <TextField
//             margin="dense"
//             label="Correct Option Index (0-3)"
//             name="correct_option"
//             type="number"
//             fullWidth
//             value={formData.correct_option}
//             onChange={handleFormChange}
//             inputProps={{ min: 0, max: 3 }}
//             required
//             sx={{ ...inputSx, mt: 2 }}
//           />
//           <TextField
//             margin="dense"
//             label="Max Score"
//             name="max_score"
//             type="number"
//             fullWidth
//             value={formData.max_score}
//             onChange={handleFormChange}
//             inputProps={{ min: 1 }}
//             required
//             sx={inputSx}
//           />
//           <TextField
//             margin="dense"
//             label="Question Order"
//             name="question_order"
//             type="number"
//             fullWidth
//             value={formData.question_order}
//             onChange={handleFormChange}
//             inputProps={{ min: 0 }}
//             helperText="Order in which questions appear"
//             sx={inputSx}
//           />
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
//           <Button
//             onClick={handleCloseModal}
//             sx={{
//               fontFamily: fontFam,
//               fontWeight: 600,
//               color: "#64748b",
//               borderRadius: "10px",
//               "&:hover": { background: "#f1f5f9" },
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             onClick={handleSaveQuestion}
//             variant="contained"
//             disabled={submitLoading}
//             sx={primaryBtnSx}
//           >
//             {submitLoading ? (
//               <CircularProgress size={20} sx={{ color: "#fff" }} />
//             ) : editingQuestion ? (
//               "Update"
//             ) : (
//               "Create"
//             )}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default AssessmentQuestions;
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  CircularProgress,
  Breadcrumbs,
  Link,
  Paper,
  Grid,
  Skeleton,
  Chip,
  Tooltip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { useATS } from "../atsModule/context/ATSContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

const TEAL = "#0c8a9b";
const FONT = "'DM Sans', 'Inter', sans-serif";

const KF_ID = "aq-kf";
if (typeof document !== "undefined" && !document.getElementById(KF_ID)) {
  const s = document.createElement("style");
  s.id = KF_ID;
  s.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');
    @keyframes fadeUp { from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)} }
  `;
  document.head.appendChild(s);
}

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    fontFamily: FONT,
    fontSize: "0.9rem",
    background: "#f8f9fa",
    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: TEAL },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: TEAL },
    "&.Mui-focused": { background: "#fff" },
  },
  "& .MuiInputLabel-root.Mui-focused": { color: TEAL },
};

const AssessmentQuestions = () => {
  const { assessmentId } = useParams();
  const navigate = useNavigate();
  const { store_id } = useATS();

  const [assessment, setAssessment] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editingQuestion, setEditingQuestion] = useState(null);
  const [formData, setFormData] = useState({
    question_text: "",
    options: ["", "", "", ""],
    correct_option: 0,
    max_score: 10,
    question_order: 0,
  });
  const [submitLoading, setSubmitLoading] = useState(false);

  const fetchData = async () => {
    if (!store_id && store_id !== 0) return;
    try {
      setLoading(true);
      const assessmentRes = await axios.get(
        `${API_BASE}/api/assessment/assessments/${assessmentId}`,
      );
      setAssessment(assessmentRes.data.data);
      const questionsRes = await axios.get(
        `${API_BASE}/api/assessment/assessment-questions/assessment/${assessmentId}`,
      );
      setQuestions(questionsRes.data.data || []);
      setError("");
    } catch (err) {
      console.error(err);
      setError("Failed to load questions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (assessmentId) fetchData();
  }, [assessmentId, store_id]);

  const handleOpenModal = (question = null) => {
    if (question) {
      setEditingQuestion(question);
      const opts =
        question.options && question.options.length === 4
          ? question.options
          : ["", "", "", ""];
      setFormData({
        question_text: question.question_text,
        options: opts,
        correct_option: question.correct_option,
        max_score: question.max_score,
        question_order: question.question_order || 0,
      });
    } else {
      setEditingQuestion(null);
      setFormData({
        question_text: "",
        options: ["", "", "", ""],
        correct_option: 0,
        max_score: 10,
        question_order: questions.length + 1,
      });
    }
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setEditingQuestion(null);
  };

  const handleFormChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleOptionChange = (index, value) => {
    const newOptions = [...formData.options];
    newOptions[index] = value;
    setFormData({ ...formData, options: newOptions });
  };

  const handleSaveQuestion = async () => {
    if (!formData.question_text.trim()) {
      alert("Question text is required");
      return;
    }
    if (formData.options.some((opt) => !opt.trim())) {
      alert("All 4 options must be filled");
      return;
    }
    setSubmitLoading(true);
    try {
      const payload = {
        assessment_id: parseInt(assessmentId),
        question_text: formData.question_text,
        options: formData.options,
        correct_option: formData.correct_option,
        max_score: formData.max_score,
        question_order: formData.question_order,
      };
      if (editingQuestion) {
        await axios.put(
          `${API_BASE}/api/assessment/assessment-questions/${editingQuestion.id}`,
          payload,
        );
      } else {
        await axios.post(
          `${API_BASE}/api/assessment/assessment-questions`,
          payload,
        );
      }
      fetchData();
      handleCloseModal();
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.statusMessage || "Failed to save question");
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleDeleteQuestion = async (questionId) => {
    if (!window.confirm("Delete this question?")) return;
    try {
      await axios.delete(
        `${API_BASE}/api/assessment/assessment-questions/${questionId}`,
      );
      fetchData();
    } catch (err) {
      alert("Failed to delete question");
    }
  };

  return (
    <Box
      sx={{
        minHeight: "80vh",
        background: "#f8f9fa",borderRadius:0.4,
        fontFamily: FONT,
        p: { xs: 2, sm: 3.5 },
      }}
    >
      {/* ── Top bar with preview/save ───────────────────────────────── */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 0.5,
          animation: "fadeUp .35s ease both",
        }}
      >
        {/* Breadcrumb */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton
            size="small"
            onClick={() => navigate(-1)}
            sx={{ color: "#868e96", p: 0.5 }}
          >
            <NavigateBeforeIcon fontSize="small" />
          </IconButton>
          <Breadcrumbs
            sx={{ "& .MuiBreadcrumbs-separator": { color: "#ced4da" } }}
          >
            <Link
              component="button"
              onClick={() => navigate("/ats/assessments")}
              underline="hover"
              sx={{
                fontFamily: FONT,
                fontSize: "0.85rem",
                fontWeight: 500,
                color: "#868e96",
              }}
            >
              Folders
            </Link>
            <Link
              component="button"
              onClick={() => navigate(-1)}
              underline="hover"
              sx={{
                fontFamily: FONT,
                fontSize: "0.85rem",
                fontWeight: 500,
                color: "#868e96",
              }}
            >
              Assessments
            </Link>
            <Typography
              sx={{
                fontFamily: FONT,
                fontSize: "0.85rem",
                fontWeight: 600,
                color: "#1a1d23",
              }}
            >
              {assessment?.title || "..."}
            </Typography>
          </Breadcrumbs>
        </Box>
        {/* Action buttons */}
        <Box sx={{ display: "flex", gap: 1.5 }}>
          <Button
            variant="outlined"
            sx={{
              fontFamily: FONT,
              fontWeight: 500,
              fontSize: "0.85rem",
              color: "#495057",
              borderColor: "#ced4da",
              borderRadius: "10px",
              textTransform: "none",
              px: 2,
              "&:hover": {
                borderColor: TEAL,
                color: TEAL,
                background: "#e6f6f8",
              },
            }}
          >
            Preview
          </Button>
          <Button
            variant="contained"
            sx={{
              background: TEAL,
              color: "#fff",
              borderRadius: "10px",
              px: 2,
              fontFamily: FONT,
              fontWeight: 600,
              fontSize: "0.85rem",
              textTransform: "none",
              boxShadow: "none",
              "&:hover": { background: "#0a7a8a", boxShadow: "none" },
            }}
            onClick={() => handleOpenModal()}
            startIcon={<AddIcon sx={{ fontSize: "16px !important" }} />}
          >
            Add Question
          </Button>
        </Box>
      </Box>

      {/* ── Assessment title ─────────────────────────────────────────── */}
      <Box sx={{ mb: 3.5, mt: 1.5, animation: "fadeUp .4s ease both" }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            fontFamily: FONT,
            color: "#1a1d23",
            fontSize: "1.55rem",
            letterSpacing: "-0.3px",
          }}
        >
          {assessment?.title}
        </Typography>
        {assessment?.description && (
          <Typography
            variant="body2"
            sx={{ color: "#868e96", mt: 0.3, fontFamily: FONT }}
          >
            {assessment.description}
          </Typography>
        )}
      </Box>

      {error && (
        <Alert
          severity="error"
          sx={{ borderRadius: "12px", mb: 3, fontFamily: FONT }}
        >
          {error}
        </Alert>
      )}

      {/* ── Loading skeletons ────────────────────────────────────────── */}
      {loading &&
        [...Array(2)].map((_, i) => (
          <Paper
            key={i}
            sx={{
              borderRadius: "16px",
              p: 3,
              mb: 2.5,
              boxShadow: "0 1px 4px rgba(0,0,0,.06)",
            }}
          >
            <Skeleton variant="text" width="30%" height={20} />
            <Skeleton variant="text" width="70%" height={24} sx={{ mt: 1.5 }} />
            <Grid container spacing={2} sx={{ mt: 1 }}>
              {[...Array(4)].map((_, j) => (
                <Grid item xs={12} sm={6} key={j}>
                  <Skeleton
                    variant="rounded"
                    height={52}
                    sx={{ borderRadius: "10px" }}
                  />
                </Grid>
              ))}
            </Grid>
          </Paper>
        ))}

      {/* ── Empty state ──────────────────────────────────────────────── */}
      {!loading && questions.length === 0 && (
        <Box sx={{ animation: "fadeUp .5s ease both" }}>
          {/* Add question placeholder card */}
          <Paper
            onClick={() => handleOpenModal()}
            sx={{
              borderRadius: "16px",
              p: 4,
              boxShadow: "none",
              border: "2px dashed #dee2e6",
              textAlign: "center",
              cursor: "pointer",
              transition: "border-color .2s, background .2s",
              "&:hover": { borderColor: TEAL, background: "#f0fbfc" },
            }}
          >
            <Box
              sx={{
                width: 52,
                height: 52,
                borderRadius: "50%",
                background: "#e6f6f8",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mx: "auto",
                mb: 1.5,
              }}
            >
              <AddIcon sx={{ fontSize: 26, color: TEAL }} />
            </Box>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, fontFamily: FONT, color: "#1a1d23" }}
            >
              Add New Question
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: "#868e96", fontFamily: FONT, mt: 0.5 }}
            >
              Multiple choice, text-based question block
            </Typography>
          </Paper>
        </Box>
      )}

      {/* ── Question Blocks ──────────────────────────────────────────── */}
      {!loading && questions.length > 0 && (
        <Box>
          {questions.map((q, idx) => {
            const delay = `${idx * 0.05}s`;
            return (
              <Paper
                key={q.id}
                sx={{
                  borderRadius: "16px",
                  p: 3,
                  mb: 2.5,
                  boxShadow:
                    "0 1px 4px rgba(0,0,0,.06), 0 0 0 1px rgba(0,0,0,.04)",
                  background: "#fff",
                  animation: `fadeUp .4s ease ${delay} both`,
                  transition: "box-shadow .2s",
                  "&:hover": { boxShadow: "0 4px 16px rgba(0,0,0,.09)" },
                }}
              >
                {/* Block header */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <Box
                      sx={{
                        width: 28,
                        height: 28,
                        borderRadius: "50%",
                        background: TEAL,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#fff",
                          fontFamily: FONT,
                          fontWeight: 700,
                          fontSize: "0.75rem",
                        }}
                      >
                        {idx + 1}
                      </Typography>
                    </Box>
                    <Typography
                      sx={{
                        fontFamily: FONT,
                        fontWeight: 700,
                        fontSize: "0.75rem",
                        color: "#868e96",
                        textTransform: "uppercase",
                        letterSpacing: "0.08em",
                      }}
                    >
                      Question Block
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0.8,
                        background: "#f8f9fa",
                        borderRadius: "8px",
                        px: 1.5,
                        py: 0.6,
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: FONT,
                          fontWeight: 500,
                          fontSize: "0.75rem",
                          color: "#868e96",
                          textTransform: "uppercase",
                          letterSpacing: "0.06em",
                        }}
                      >
                        Points:
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: FONT,
                          fontWeight: 700,
                          fontSize: "0.85rem",
                          color: "#1a1d23",
                        }}
                      >
                        {q.max_score}
                      </Typography>
                    </Box>
                    <Tooltip title="Delete question">
                      <IconButton
                        size="small"
                        onClick={() => handleDeleteQuestion(q.id)}
                        sx={{
                          color: "#ced4da",
                          borderRadius: "8px",
                          "&:hover": {
                            color: "#e03131",
                            background: "#fff5f5",
                          },
                        }}
                      >
                        <DeleteIcon sx={{ fontSize: 17 }} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Edit question">
                      <IconButton
                        size="small"
                        onClick={() => handleOpenModal(q)}
                        sx={{
                          color: "#ced4da",
                          borderRadius: "8px",
                          "&:hover": { color: TEAL, background: "#e6f6f8" },
                        }}
                      >
                        <EditIcon sx={{ fontSize: 17 }} />
                      </IconButton>
                    </Tooltip>
                    <DragIndicatorIcon
                      sx={{ color: "#dee2e6", fontSize: 20, cursor: "grab" }}
                    />
                  </Box>
                </Box>

                {/* Question text label */}
                <Typography
                  sx={{
                    fontFamily: FONT,
                    fontSize: "0.78rem",
                    fontWeight: 600,
                    color: "#adb5bd",
                    textTransform: "uppercase",
                    letterSpacing: "0.06em",
                    mb: 0.8,
                  }}
                >
                  Question Text
                </Typography>

                {/* Question text box */}
                <Box
                  sx={{
                    p: 1.8,
                    borderRadius: "10px",
                    border: "1px solid #e9ecef",
                    background: "#fafbfc",
                    mb: 2.5,
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: FONT,
                      fontSize: "0.95rem",
                      color: "#1a1d23",
                      lineHeight: 1.6,
                    }}
                  >
                    {q.question_text}
                  </Typography>
                </Box>

                {/* Options grid */}
                <Grid container spacing={1.5}>
                  {q.options.map((opt, optIdx) => {
                    const isCorrect = optIdx === q.correct_option;
                    return (
                      <Grid item xs={12} sm={6} key={optIdx}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.2,
                            p: 1.4,
                            borderRadius: "10px",
                            border: `1.5px solid ${
                              isCorrect ? TEAL : "#e9ecef"
                            }`,
                            background: isCorrect ? "#e6f6f8" : "#fafbfc",
                            transition: "all .15s",
                          }}
                        >
                          {isCorrect ? (
                            <RadioButtonCheckedIcon
                              sx={{ fontSize: 18, color: TEAL, flexShrink: 0 }}
                            />
                          ) : (
                            <RadioButtonUncheckedIcon
                              sx={{
                                fontSize: 18,
                                color: "#ced4da",
                                flexShrink: 0,
                              }}
                            />
                          )}
                          <Box sx={{ flex: 1 }}>
                            <Typography
                              sx={{
                                fontFamily: FONT,
                                fontSize: "0.7rem",
                                fontWeight: 600,
                                color: isCorrect ? TEAL : "#adb5bd",
                                textTransform: "uppercase",
                                letterSpacing: "0.05em",
                                mb: 0.1,
                              }}
                            >
                              Option {String.fromCharCode(65 + optIdx)}
                              {isCorrect ? " (Correct Answer)" : ""}
                            </Typography>
                            <Typography
                              sx={{
                                fontFamily: FONT,
                                fontSize: "0.88rem",
                                color: isCorrect ? "#0a4f58" : "#495057",
                                fontWeight: isCorrect ? 500 : 400,
                              }}
                            >
                              {opt}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    );
                  })}
                </Grid>

                {/* Footer chips */}
                <Box
                  sx={{
                    display: "flex",
                    gap: 1.5,
                    mt: 2,
                    pt: 2,
                    borderTop: "1px solid #f1f3f5",
                  }}
                >
                  <Chip
                    label={`Order: ${q.question_order}`}
                    size="small"
                    sx={{
                      fontFamily: FONT,
                      fontWeight: 500,
                      fontSize: "0.75rem",
                      background: "#f1f3f5",
                      color: "#868e96",
                      borderRadius: "6px",
                      height: 24,
                    }}
                  />
                </Box>
              </Paper>
            );
          })}

          {/* Add new question card */}
          <Paper
            onClick={() => handleOpenModal()}
            sx={{
              borderRadius: "16px",
              p: 3.5,
              boxShadow: "none",
              border: "2px dashed #dee2e6",
              textAlign: "center",
              cursor: "pointer",
              transition: "border-color .2s, background .2s",
              "&:hover": { borderColor: TEAL, background: "#f0fbfc" },
            }}
          >
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: "50%",
                background: "#e6f6f8",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mx: "auto",
                mb: 1,
              }}
            >
              <AddIcon sx={{ fontSize: 22, color: TEAL }} />
            </Box>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                fontFamily: FONT,
                color: "#1a1d23",
                fontSize: "0.95rem",
              }}
            >
              Add New Question
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#868e96",
                fontFamily: FONT,
                mt: 0.3,
                fontSize: "0.82rem",
              }}
            >
              Multiple choice, text-based question block
            </Typography>
          </Paper>
        </Box>
      )}

      {/* ── Add/Edit Question Modal ──────────────────────────────────── */}
      <Dialog
        open={modalOpen}
        onClose={handleCloseModal}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            boxShadow: "0 20px 60px rgba(0,0,0,.15)",
            fontFamily: FONT,
          },
        }}
      >
        <DialogTitle
          sx={{
            fontFamily: FONT,
            fontWeight: 700,
            fontSize: "1rem",
            color: "#1a1d23",
            pt: 2.5,
            pb: 0.5,
          }}
        >
          {editingQuestion ? "Edit Question" : "New Question"}
        </DialogTitle>
        <DialogContent sx={{ pt: 1.5 }}>
          <TextField
            autoFocus
            margin="dense"
            label="Question Text"
            name="question_text"
            fullWidth
            multiline
            rows={2}
            value={formData.question_text}
            onChange={handleFormChange}
            required
            sx={inputSx}
          />
          <Typography
            sx={{
              mt: 2,
              mb: 0.5,
              fontFamily: FONT,
              fontWeight: 600,
              fontSize: "0.85rem",
              color: "#495057",
            }}
          >
            Options (exactly 4)
          </Typography>
          <Grid container spacing={2}>
            {[0, 1, 2, 3].map((idx) => (
              <Grid item xs={12} sm={6} key={idx}>
                <TextField
                  margin="dense"
                  label={`Option ${String.fromCharCode(65 + idx)}`}
                  fullWidth
                  value={formData.options[idx]}
                  onChange={(e) => handleOptionChange(idx, e.target.value)}
                  required
                  sx={inputSx}
                />
              </Grid>
            ))}
          </Grid>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: 2,
              mt: 1,
            }}
          >
            <TextField
              margin="dense"
              label="Correct Option (0-3)"
              name="correct_option"
              type="number"
              fullWidth
              value={formData.correct_option}
              onChange={handleFormChange}
              inputProps={{ min: 0, max: 3 }}
              required
              sx={inputSx}
            />
            <TextField
              margin="dense"
              label="Max Score"
              name="max_score"
              type="number"
              fullWidth
              value={formData.max_score}
              onChange={handleFormChange}
              inputProps={{ min: 1 }}
              required
              sx={inputSx}
            />
            <TextField
              margin="dense"
              label="Question Order"
              name="question_order"
              type="number"
              fullWidth
              value={formData.question_order}
              onChange={handleFormChange}
              inputProps={{ min: 0 }}
              sx={inputSx}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 2.5, pb: 2.5, gap: 1 }}>
          <Button
            onClick={handleCloseModal}
            sx={{
              fontFamily: FONT,
              fontWeight: 500,
              color: "#868e96",
              borderRadius: "8px",
              textTransform: "none",
              "&:hover": { background: "#f1f3f5" },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveQuestion}
            variant="contained"
            disabled={submitLoading}
            sx={{
              background: TEAL,
              borderRadius: "8px",
              fontFamily: FONT,
              fontWeight: 600,
              textTransform: "none",
              boxShadow: "none",
              "&:hover": { background: "#0a7a8a", boxShadow: "none" },
            }}
          >
            {submitLoading ? (
              <CircularProgress size={18} sx={{ color: "#fff" }} />
            ) : editingQuestion ? (
              "Update"
            ) : (
              "Create"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AssessmentQuestions;